<template>
  <div>
    <DataTable v-if="rates" :value="rates" :paginator="rates.length > 15" :rows="15" contextMenu class="rates-table mx-auto w-full max-w-[50rem]"
      :tableStyle="{ width: '100%' }">
      <Column class="rates-table__column" field="country" :header="$t('global.country')" />
      <Column class="rates-table__column" field="promoRate" :header="$t('components.bmDefaultRates.promo')">
        <template #body="{ data }">
          {{ data.promoRate.toFixed(4) }} €
        </template>
      </Column>
      <Column class="rates-table__column" field="promoInternationalRate"
        :header="$t('components.bmDefaultRates.promoInternationalRate')">
        <template #body="{ data }">
          {{ data.promoInternationalRate.toFixed(4) }} €
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
import DataTable from "primevue/datatable";
import Column from "primevue/column";
const { data, error } = await useFetch('/api/rates')

let rates = ref<Array<object>>([]);

if (data.value) {
  rates.value = data.value as Array<object>;
} else if (error.value) {
  console.warn("API Error:", error.value);
}
</script>

<style lang="scss">
.rates-table {
  width: 100%;

  & .p-datatable-thead {
    margin-bottom: 10px;
    text-align: right;
  }

  &__column {
    text-align: left;
  }

  &__column:last-child {
    text-align: center;

    & .p-column-header-content {
      display: flex;
      justify-content: flex-start;
    }
  }

  & .p-datatable-tbody {
    padding-top: 10px;
  }
}
</style>
